import SolicitudesDatosPage from 'pages/admin/SolicitudesDatos';
import MisDatosPage from 'pages/MisDatos';
import Home from 'pages/admin/Home';
import Users from 'pages/admin/Users';
import Client from 'pages/admin/Client';
import DatosCliente from 'pages/DatosCliente';
import Mantencion from 'pages/Specialist/mantenciones/Mantencion';
import Category from 'pages/admin/Maintance/Category';
import Activities from 'pages/admin/Maintance/Activities';
import Asignations from 'pages/admin/Maintance/Asignations';
import Mantenciones from 'pages/admin/Mantenciones';
import MantencionesCalendario from 'pages/admin/MantencionesCalendario';
import IDClientePage from 'pages/admin/IDClientePage/IDClientePage';
import PanelOperacionalPage from 'pages/admin/PanelOperacional/PanelOperacionalPage';
import HallazgosPageGlobal from 'pages/admin/HallazgosPage';
import TecnicosPage from 'pages/admin/Tecnicos/TecnicosPage';
import ReportesVisitaPage from 'pages/admin/ReportesVisita/ReportesVisitaPage';
import ReporteVisitaViewer from 'components/ReporteVisita/Viewer/ReporteVisitaViewer';
import TicketsPage from 'pages/admin/Tickets/TicketsPage';
import ODTGanttPage from 'pages/admin/ODTGantt/ODTGanttPage';
import CorreosPage from 'pages/admin/Correos/CorreosPage';

import { mainRoute, catchAllRoute } from '../helpers';

const supervisorRoutes = [
  mainRoute('/admin/tickets', TicketsPage),
  mainRoute('/admin/correos', CorreosPage),
  mainRoute('/admin/panel-operacional', PanelOperacionalPage),
  mainRoute('/admin/tecnicos', TecnicosPage),
  mainRoute('/admin/reportes-visita', ReportesVisitaPage),
  mainRoute('/admin/reportes-visita/:id', ReporteVisitaViewer),
  mainRoute('/admin/hallazgos', HallazgosPageGlobal),
  mainRoute('/admin/users', Users),
  mainRoute('/admin/mantenciones', Mantenciones),
  mainRoute('/admin/mantenciones/calendario', MantencionesCalendario),
  mainRoute('/admin/mantenciones/:id', Mantencion),
  mainRoute('/admin/maintance/asignations', Asignations),
  mainRoute('/admin/mantenciones/actividades', Activities),
  mainRoute('/admin/maintance/categories', Category),
  mainRoute('/admin', Home),
  mainRoute('/', Home),
  mainRoute('/admin/client', Client),
  mainRoute('/admin/client/:id/datos', DatosCliente),
  mainRoute('/admin/clientes/:id', IDClientePage),
  mainRoute('/admin/odt/:idOrder/gantt', ODTGanttPage),
  // Ley 21.719: el backend habilita al supervisor en la bandeja (denyTypes en api/index.js).
  mainRoute('/admin/solicitudes-datos', SolicitudesDatosPage),
  // Ley 21.719: toda persona con cuenta puede ejercer sus derechos sobre sus datos.
  mainRoute('/mis-datos', MisDatosPage),
  catchAllRoute(),
];

export default supervisorRoutes;
